module.exports = __webpack_public_path__ + "static/img/modalactive.63abae61.png";